import { deepClone } from "fast-json-patch/lib/core";
import { ActionTree } from "vuex";
import { ILargeMailingState } from "./states.store";
import ReportStoreTypes from "./define-types.store";
import { MAILING_METHOD } from "../../../common/report.constant";

const largeMailingActions = <ActionTree<ILargeMailingState, any>>{

    /** CALL SERVICE TO POST DATA */
    [ReportStoreTypes.Set.POST_DATA_LARGEMAILING]: ({ getters, commit }) => {
        const formData = new FormData();
        let payload = deepClone(getters[ReportStoreTypes.Get.GET_LARGEMAILING]);
             
        formData.append('Module', payload.Module);
        formData.append('UserId', payload.UserId);
        formData.append('FromEmail', payload.FromEmail);
        formData.append('EmailLangId', payload.EmailLangId);
        formData.append('Subject', payload.Subject);
        formData.append('SenderName', payload.SenderName);
        // formData.append('MailingMethod', payload.MailingMethod);
        // formData.append('HtmlContent', payload.HtmlContent);
        formData.append('PersonIds', payload.PersonIds);
        // formData.append('PersonInfos', payload.PersonInfos);
        // formData.append('DemandInfos', payload.DemandInfos);
        formData.append('TreviPartnerIDs', payload.TreviPartnerIDs);
        formData.append('IsTest', payload.IsTest);
        formData.append('IsDryRun', payload.IsDryRun || false);

        formData.append('ToEmail', payload.IsTest? payload.ToTestingMail :payload.ToEmail);

        // Case of HTMLURL is input
        let mailingMethod = payload.HtmlUrl !== "" && payload.MailingMethod === MAILING_METHOD.HtmlFile  ? MAILING_METHOD.HtmlUrl : payload.MailingMethod;
    
        switch (mailingMethod) {
            case MAILING_METHOD.HtmlUrl: //HtmlUrl =1
                formData.append('FileUrl', payload.HtmlUrl)
                break;
            case MAILING_METHOD.Zip: //zip = 3,
                let origin = getters[ReportStoreTypes.Get.GET_LARGEMAILING];
                formData.append('FileStream', origin.UploadFile)
                break;
            default:
                formData.append('HtmlContent', payload.HtmlContent);
                break;
        }

        // The same way: use HtmlContent as main param
        mailingMethod = mailingMethod === MAILING_METHOD.HtmlFile || mailingMethod === MAILING_METHOD.Picture ? MAILING_METHOD.Omnicomposer : mailingMethod;
        formData.append('MailingMethod', mailingMethod);

        const config = {
            headers: {
              "content-type": "multipart/form-data"
            },
        };
        return getters.service[ReportStoreTypes.Service.SEND_LARGEMAILING](formData, config)
            .then((data: any) => {
                return Promise.resolve(data);
            })
            .catch(error => {
                return Promise.reject(error);
            });
        
    },

    /** CALL SERVICE TO GET PERSONS WHO HAVE INVALID EMAIL TO SEND */
    [ReportStoreTypes.Get.INVALID_EMAILS]: (
        { getters, commit },
        personIds: number[]
    ) => {
        return getters.service[ReportStoreTypes.Service.GET_INVALID_PERSON_EMAILS]( personIds)
        .then((data: any) => {
            return Promise.resolve(data);
        })
        .catch(error => {
            return Promise.reject(error);
        });
    },
}
export default largeMailingActions;